import { ProductTag } from '@woolworthsnz/trader-api';

export const shouldShowTagAsStrap = (tagType: ProductTag.TagTypeEnum | undefined): boolean =>
	tagType !== ProductTag.TagTypeEnum.Other &&
	tagType !== ProductTag.TagTypeEnum.IsNew &&
	tagType !== ProductTag.TagTypeEnum.HasBonusPoints;
